import api from "./auth.api";

export enum TranscriptionProvider {
  DEEPGRAM = "deepgram",
  ASSEMBLYAI = "assemblyai"
}

export interface TelegramProviderResponse {
  provider: TranscriptionProvider;
}

export interface UpdateTelegramProviderRequest {
  provider: TranscriptionProvider;
}

export interface UpdateTelegramProviderResponse {
  success: boolean;
  provider: TranscriptionProvider;
}

export interface PublicSettingsResponse {
  freePreviewEnabled: boolean;
  freePreviewLimitSeconds: number;
  freePreviewMaxPerAccount: number;
  freePreviewMaxFileSizeBytes: number;
  freePreviewUrlMaxMinutes: number;
  trialPlanEnabled: boolean;
}

export const settingsApi = {
  getPublicSettings: async (): Promise<PublicSettingsResponse> => {
    const response = await api.get<PublicSettingsResponse>("/settings/public");
    return response.data;
  },

  getTelegramProvider: async (): Promise<TelegramProviderResponse> => {
    const response = await api.get<TelegramProviderResponse>("/api/admin/settings/telegram-provider");
    return response.data;
  },

  updateTelegramProvider: async (provider: TranscriptionProvider): Promise<UpdateTelegramProviderResponse> => {
    const response = await api.patch<UpdateTelegramProviderResponse>("/api/admin/settings/telegram-provider", {
      provider
    });
    return response.data;
  }
};
